import l10n from '../../../shared/strings';
import { resolveChannelLabel } from '../../../store/products/helpers/showPublishedToChannelToast';

const MASTER_LAYER_VALUE = 'master';

export const normalizeProductLayerOptions = (options = [], salesChannels = []) => (
  options.map((option) => {
    if (option === MASTER_LAYER_VALUE) {
      return {
        label: l10n.SEARCH.productLayer.master,
        value: MASTER_LAYER_VALUE,
      };
    }

    return {
      label: resolveChannelLabel(option, salesChannels),
      value: String(option),
    };
  })
);

export const toProductLayerDropdownItems = (options = []) => (
  options.map(({ label, value }) => ({
    title: label,
    value,
    _id: value,
  }))
);

export const restoreProductLayerFilterValue = (layerIds = [], normalizedOptions = []) => {
  const optionByValue = normalizedOptions.reduce((acc, option) => {
    acc[option.value] = option;
    return acc;
  }, {});

  return layerIds.map((layerId) => {
    const value = String(layerId);
    const option = optionByValue[value];

    return {
      title: option?.label || value,
      value,
      _id: value,
    };
  });
};

export const serializeProductLayerForRoute = (value) => {
  if (!Array.isArray(value) || !value.length) return value;

  return value.map((item) => item?.value ?? item?._id ?? item);
};

export const getDefaultProductLayerIds = (options = []) => (
  Array.isArray(options) && options.length ? [...options] : [MASTER_LAYER_VALUE]
);

export const buildDefaultProductLayerFilter = (options = [], salesChannels = []) => {
  const layerIds = getDefaultProductLayerIds(options);
  const normalizedOptions = normalizeProductLayerOptions(layerIds, salesChannels);

  return {
    operator: 'oneOf',
    value: restoreProductLayerFilterValue(layerIds, normalizedOptions),
  };
};
